import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { MODELS as STATIC_MODELS, SHORT_FILMS as STATIC_SHORT_FILMS } from '../data/galeria.js';

const GalleryConfigContext = createContext(null);

export function GalleryConfigProvider({ children }) {
  const [models, setModels] = useState(STATIC_MODELS);
  const [shortFilms, setShortFilms] = useState(STATIC_SHORT_FILMS);
  const [loading, setLoading] = useState(true);
  const [fromApi, setFromApi] = useState(false);

  const fetchGallery = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/gallery');
      if (!res.ok) throw new Error('API error');
      const data = await res.json();
      const apiModels = data.models || [];
      const apiFilms = data.shortFilms || [];
      if (apiModels.length > 0 || apiFilms.length > 0) {
        setModels(apiModels);
        setShortFilms(apiFilms);
        setFromApi(true);
      }
    } catch (_) {
      /* fallback: mantiene datos estáticos */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchGallery();
  }, [fetchGallery]);

  return (
    <GalleryConfigContext.Provider value={{ models, shortFilms, loading, fromApi, refreshGallery: fetchGallery }}>
      {children}
    </GalleryConfigContext.Provider>
  );
}

export function useGalleryConfig() {
  const ctx = useContext(GalleryConfigContext);
  if (!ctx) return { models: STATIC_MODELS, shortFilms: STATIC_SHORT_FILMS, loading: false, fromApi: false, refreshGallery: async () => {} };
  return ctx;
}

export function useModelsForGallery() {
  const { models } = useGalleryConfig();
  return models;
}

export function useShortFilmsForGallery() {
  const { shortFilms } = useGalleryConfig();
  return shortFilms;
}
